import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from '../icons/SalesIcons';
export function DreamSection() {
  return <section className="relative bg-gradient-to-br from-[#FDF8F4] via-[#FFFAF5] to-[#FDF8F4] py-16 md:py-24 overflow-hidden" data-id="element-113">
      {/* Soft glow background */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#C4A882]/5 via-transparent to-[#D4A0A0]/5 pointer-events-none" data-id="element-114" />

      <div className="max-w-6xl mx-auto px-4" data-id="element-115">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-116">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-117">
            <div className="flex items-center gap-3 mb-6" data-id="element-118">
              <HeartIcon size={32} className="text-[#9B2335]" data-id="element-119" />
              <h2 className="font-heading text-3xl md:text-4xl text-[#5C4033]" data-id="element-120">
                Imagina Esto...
              </h2>
            </div>

            <div className="space-y-6 text-lg text-[#2D2926] leading-relaxed" data-id="element-121">
              <p className="font-script text-2xl text-[#9B2335]" data-id="element-122">
                Imagina abrir tu espacio de trabajo y saber exactamente qué vas
                a hacer.
              </p>

              <p data-id="element-123">
                Tienes la cera correcta. El pabilo adecuado para ese recipiente.
                La fragancia medida al porcentaje exacto. Y en menos de una
                hora, tienes frente a ti una vela que se ve de tienda. Que huele
                increíble. Que tiene un acabado perfecto.
              </p>

              <p className="font-bold text-[#5C4033]" data-id="element-124">
                Y sabes que la próxima también te va a salir bien. Y la de
                después. Y la de después.
              </p>

              <p className="font-script text-2xl text-[#9B2335]" data-id="element-125">
                Imagina mandar una foto de tus creaciones a tu familia y que la
                respuesta sea: "¿Dónde las vendo? ¿Cuánto cuestan?"
              </p>

              <p data-id="element-126">
                Imagina tener una entrada adicional de dinero haciendo algo que
                genuinamente disfrutas, desde tu casa, con tus propias manos.
              </p>

              <div className="p-6 bg-white/80 rounded-xl border border-[#C4A882]/30 shadow-lg" data-id="element-127">
                <p className="text-xl font-bold text-[#9B2335]" data-id="element-128">
                  Eso no es un sueño. Es exactamente lo que ocurre cuando tienes
                  el sistema correcto.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-129">
            <div className="relative" data-id="element-130">
              {/* Decorative glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#C4A882]/30 to-[#D4A0A0]/20 rounded-3xl blur-2xl" data-id="element-131" />

              <img src="https://cdn.magicpatterns.com/uploads/sXFfTux8eXuLGmAAf7suUJ/mk-2.png" alt="Vista móvil del curso Ilumina y Crea" className="relative w-full max-w-md mx-auto h-auto rounded-2xl shadow-2xl" data-id="element-132" />

              {/* Floating elements */}
              <motion.div animate={{
              y: [0, -15, 0],
              rotate: [0, 5, 0]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="absolute -top-4 -left-4 md:top-8 md:left-0 bg-[#C4A882] text-white px-4 py-2 rounded-full shadow-lg" data-id="element-133">
                <span className="font-bold text-sm" data-id="element-134">
                  Creaciones Profesionales
                </span>
              </motion.div>

              <motion.div animate={{
              y: [0, 10, 0],
              rotate: [0, -3, 0]
            }} transition={{
              duration: 3.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.5
            }} className="absolute -bottom-4 -right-4 md:bottom-12 md:right-0 bg-[#9B2335] text-white px-4 py-2 rounded-full shadow-lg" data-id="element-135">
                <span className="font-bold text-sm" data-id="element-136">Desde Tu Casa</span>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}